module.exports = __webpack_public_path__ + "static/media/story-1.24268b24.jpeg";